

<template>

<div>
    <v-row align="center" justify="center">
        <v-card elevation="2">
            <v-card-title class="ma-0 pa-3">Vehicle Information</v-card-title>
            <v-divider class="mx-4 ma-1"></v-divider>
            <v-form ref="veh" style="margin-left:2%; margin-right:2%" lazy-validation>
                <v-row style="height: 50px;">
                    <v-col cols="4">
                        <v-text-field v-model="vehicle.key.make" :rules="[rules.required]" dense type="text" required label="Make:" outlined></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="vehicle.key.model" :rules="[rules.required]" dense type="text" required label="Model:" outlined></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="vehicle.key.year" :rules="[rules.required]" dense type="text" required label="Year:" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-card-text style="margin-left:-2%; margin-top:1%"> System Types: </v-card-text>
                <v-row class="ma-0 pa-0">
                    <v-chip-group multiple style="margin-left:15%; margin-right:1%; margin-top:-2%" column>
                        <v-chip @click="badge(sys)" :color="check(sys.sysType)" text-color="white" v-for="sys in sysTypes" filter>
                            {{sys.sysType}}
                        </v-chip>
                    </v-chip-group>
                </v-row>

            </v-form>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text-color="white" text @click="save">
                    Save
                </v-btn>
                <v-btn color="red" text-color="white" text @click="cancel">
                    Cancel
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-row>

</div>

</template>

<script>

export default {
    created() {
            this.$overlay.show(this);
            this.$api.getSystemTypes().then((response) => {
                if (response.status == 200) {
                    this.sysTypes = response.data;
                }
                this.$overlay.hide();
            }).catch(error => {
                this.$overlay.hide();
            });

        },
        name: "",
        data: () => ({
            vehicle: {
                key: {
                    make: '',
                    model: '',
                    year: null,
                },
                sysTypes: [

                ]
            },
            sysTypes: [],
            rules: {
                required: value => !!value || 'Required.'
            }
        }),
        methods: {
            save() {
                    if (this.$refs.veh.validate()) {
                        this.$overlay.show(this);
                        this.$api.saveVehicle(this.vehicle).then((response) => {
                            if (response.status == 202) {
                                this.$toasted.success("Vehicle Added").goAway(800);
                                this.vehicle = {
                                    key: {
                                        make: '',
                                        model: '',
                                        year: null,
                                    },
                                    sysTypes: [

                                    ]
                                };
                                this.cancel();
                            }
                            this.$overlay.hide();
                        }).catch(error => {
                            this.$overlay.hide();
                        });
                    }
                },
                badge(sys) {
                    let x = this.exists(this.vehicle.sysTypes, sys.sysType)
                    if (x >= 0) {
                        this.vehicle.sysTypes.splice(x, 1);
                    } else {
                        this.vehicle.sysTypes.push(sys);
                    }
                },
                check(sys) {
                    var s = "red"
                    for (var i = 0; i < this.vehicle.sysTypes.length; i++) {
                        if (this.vehicle.sysTypes[i].sysType.localeCompare(sys) == 0) {
                            s = "success"
                        }
                    }
                    return s;
                },
                exists(roles, sys) {
                    var s = -1;
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].sysType.localeCompare(sys) == 0) {
                            s = i;
                        }
                    }
                    return s;
                },
                cancel() {
                    this.$router.go(-1);
                }
        }
}

</script>
